import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Button from '@material-ui/core/Button';
import { CenterFocusStrong } from '../../../node_modules/@material-ui/icons/index';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { useHistory } from 'react-router-dom';

export default function WarningOnOpenOrdersPage(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const history = useHistory();
    const [displayWarning, setDisplayWarning] = useState(false);

    useEffect(
        () => {

            if (Notification.permission != 'granted' && !localStorage.getItem('NotificationWarningDismissed')) {
                setDisplayWarning(true);
            }

        }, []
    )

    const dismissClicked = () => {
        setDisplayWarning(false);
        localStorage.setItem('NotificationWarningDismissed', 'true');
    }

    return (
        <React.Fragment>
            {
                displayWarning ?
                    <div className={classes.root}>
                        <div className={classes.wrapperDiv}>

                            <div className={classes.rightSideWrapper}>
                                <div className={classes.dismissDiv} onClick={() => dismissClicked()}>
                                    <HighlightOffIcon></HighlightOffIcon>
                                </div>
                                <div className={classes.iconAndMessageWrapper}>
                                    <NotificationsIcon></NotificationsIcon>

                                    {
                                        globalContext.globalState.selectedGuiLanguage == 'tr' ?
                                            <span className={classes.message} >
                                                Sipariş geldiğinde görüntülü uyarı da almak ister misiniz?
                                            </span> 
                                            :
                                            <span className={classes.message} >
                                                Would you like to have visual notifications when your order arrives?
                                            </span>
                                    }


                                </div>

                                <Button className={classes.yesButton} onClick={()=> history.push('/settings/push-notification')} variant="contained">ok</Button>
                            </div>

                        </div>
                    </div>
                    : null
            }
        </React.Fragment>
    )
}

const useStyles = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',

    },
    message: {
        marginLeft: '10px',
    },
    wrapperDiv: {
        width: 'calc(95% - 20px)',
        display: 'flex',
        alignItems: 'center',
        color: '#fff',
        fontWeight: 500,
        fontSize: '1.1rem',
        backgroundColor: '#2196f3',
        margin: '20px 0',
        borderRadius: '4px',
        boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
        padding: '10px 10px',
    },
    rightSideWrapper: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
    dismissDiv: {
        display: 'flex',
        justifyContent: 'flex-end',
        cursor: 'pointer',
    },
    yesButton: {
        alignSelf: 'flex-end',
    },
    iconAndMessageWrapper: {
        display: 'flex',
        alignItems: 'center',
        margin: '10px 0',
        justifyContent: 'center',
    },
});